<template>

    <form-container title="Saved claim form details" ref="policyLookup">
    
      <p class="lead">If you have a saved claim form you can resume the claim process by entering the relevant details below.</p>
        <div class="form-group">
          <label for="policy number">Claimant email address</label>
          <input type="text" 
                id="emailAddress" 
                fieldlabel="Email address"
                v-model="email"
                v-taurus-validator="'required'"
                class="form-control form-control-lg">
          <div class="" name="emailAddress" invalidfeedback="Please enter a your email address"></div>
        </div>

        <div class="form-group">
          <label for="policy number">Policy number</label>
          <input type="text" 
                id="policyNumber" 
                fieldlabel="Policy number"
                v-model="number"
                v-taurus-validator="'required'"
                class="form-control form-control-lg">
          <div class="" name="policyNumber" invalidfeedback="Please enter the policy number"></div>
        </div>
        
        <div class="form-group">
          <label for="policyholders date of birth">Claimant's date of birth</label>
          <input type="text" 
                 id="policyDOB"                  
                 fieldlabel="Policyholder's date of birth" 
                 placeholder="DD/MM/YYYY" 
                 v-model="dob" 
                 v-taurus-validator="'required|date_format:DD/MM/YYYY'" 
                 class="form-control form-control-lg">
          <div class="" name="policyDOB" invalidfeedback="Please enter the your date of birth in the following format DD/MM/YYYY"></div>
        </div>

        <label for="policy holder's postcode">Claimant's postcode</label>
        <input type="text" 
               id="policyPostcode" 
               ref="policyPostcode" 
               fieldlabel="Policyholder's postcode" 
               placeholder="" 
               v-model="postcode" 
               v-taurus-validator="'required'" 
               class="form-control form-control-lg">
        <div class="" name="policyPostcode" invalidfeedback="Please enter your postcode"></div>
        <transition name="fade">
            <div
                v-if="apiMsg.type != 0 && nextAttempted"
                class="text-danger mt-5 mb-5">
                <i class="fas fa-exclamation-triangle mr-2"></i><strong>{{apiMsg.text}}</strong>
            </div>
        </transition>

        <form-button-bar
            :back_button_show='false'
            :next_button_enable='true'
            :next_button_show='true'
            :next_button_icon_enable='true'
            :next_button_action='handleNextClick' />

        <loading :active.sync="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
    </form-container>

</template>

<script>

import tigaClaimForm from '../../mixins/tigaClaimForm'
import FormContainer from '@/components/FormContainer.vue'
import FormButtonBar from '@/components/standaloneForm/FormButtonBar.vue'

import loading from 'vue-loading-overlay'

import moment from 'moment'

export default {
  name: 'savedFormLookup',
  components: {
    loading,
    FormContainer,
    FormButtonBar,
  },
  data () {
    return {
      email: '',
      number: '',
      dob: '',
      postcode: '',
      nextAttempted: false
    }
  },
  mixins: [
    tigaClaimForm
  ],
  mounted () {
    this.reset()
  },
  computed: {

  },
  methods: {
    handleNextClick () {
      this.nextAttempted = true
      if (this.checkForm()) {
        let { email, number, dob, postcode } = this
        this.resumeSavedForm(email, number, dob, postcode, '/makeaclaim/6')
      }      
    },
  }
}
</script>
